import React from 'react'
import MyTabButton from './MyTabButton'

const MyTabButtons = ({ value, setValue, list }) => {

  return (
    <div className='myTabButtons'>
		{
			list && list.length > 0 ?
				list.map(item => {
					return (
						<MyTabButton 
							key={item.value}
							name={item.name} 
							value={item.value}
							setValue={setValue}
							valueChoose={value}
						/>
					)
				}) 
			: ''
		}
		{/* <MyTabButton 
			name={'Українська'} 
			locale={'ua'}
			localeChoose={locale}
			setLocaleChoose={setLocale}
		/>
		<MyTabButton 
			name={'Англійська'} 
			locale={'en'}
			localeChoose={locale}
			setLocaleChoose={setLocale}
		/> */}
    </div>
  )
}

export default MyTabButtons